import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const bankService = {
    async getDropdownAsync()
    {
         const response=await apiClient.get(endPoints.bank.dropdown);
         return response.data
       
    }
}